import React from 'react';
import { ArchitectureAgent } from '../components/ArchitectureAgent/ArchitectureAgent';
import './ArchitectureAgentPage.css';

const ArchitectureAgentPage: React.FC = () => {
  return (
    <div className="architecture-agent-page">
      <div className="page-header">
        <h1>Architecture Agent</h1>
        <p>
          Validate code against architectural patterns, get guidance, and access best practices for
          the Krysalis Business project.
        </p>
      </div>
      <div className="page-content">
        <ArchitectureAgent />
      </div>
    </div>
  );
};

export default ArchitectureAgentPage;
